var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterrogation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB2F16",
    d: "M54.201 40.398l-8.39 11.137a1.19 1.19 0 0 1-1.779.12l-4.327-4.304a1 1 0 0 0-1.41 1.418l4.333 4.31a3.195 3.195 0 0 0 2.474.912 3.17 3.17 0 0 0 2.31-1.257l8.387-11.132a1 1 0 0 0-1.598-1.204zM47 64c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.603 17 17 17zm0-2c-8.29 0-15-6.713-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    d: "M54.739 0c5.019 0 9.115 3.979 9.257 8.937l.004.266V30a1 1 0 0 1-1.993.117L62 30V9.203c0-3.892-3.122-7.07-7.017-7.199L54.739 2H9.269C5.337 2 2.133 5.098 2.004 8.96L2 9.204V33h25a1 1 0 0 1 .993.883L28 34a1 1 0 0 1-.883.993L27 35H2.1c.562 3.325 3.427 5.879 6.919 5.996l.25.004h14.71a1.002 1.002 0 0 1 .995 1.225l-3 13a1 1 0 0 1-.971.775H13a1 1 0 0 1-.117-1.993L13 54h7.204l2.538-11H9.269C4.243 43 .146 39.029.004 34.071l-.001-.017L0 34V9.203C0 4.21 4.01.145 9 .003L9.27 0h45.469z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterrogation);
export default __webpack_public_path__ + "static/media/interrogation.20e7c9e2eca6b297aa4c68e90a86fdef.svg";
export { ForwardRef as ReactComponent };